<div class="container">
  <mic-breadcrumb id="repairs-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('productDataText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('repairsText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  <h3 class="m-0 mt-3" id="repairs-heading">{{ translationService.translate('repairsText') }}</h3>

  <div class="action-bar">
    <button id="reset-filters" type="button" mat-flat-button color="accent" (click)="resetFilters()">
      <mat-icon>refresh</mat-icon>
      {{ translationService.translate('clearSelectionText') }}
    </button>
    <span
      [matTooltip]="
        productSaveDisabled
          ? this.translationService.translate('comingSoonText')
          : !isSaveEnabled
          ? this.translationService.translate('userCannotSaveText')
          : !isModified
          ? this.translationService.translate('noModifiedText')
          : null
      "
      matTooltipPosition="above"
    >
      <button id="save" type="button" mat-flat-button color="primary" [disabled]="!isSaveEnabled || !isModified" (click)="save()">
        <mat-icon>save</mat-icon>
        {{ translationService.translate('saveLinkText') }}
      </button>
    </span>
    <button mat-flat-button color="primary" (click)="openExportModal()">
      <mat-icon>download</mat-icon>
      {{ translationService.translate('exportButtonText') }}
    </button>
  </div>

  <mat-card class="search-card mt-3">
    <form [formGroup]="filterForm">
      <div class="grid-container">
        <app-dropdown-search-single-select
          id="codeDropdown"
          label="{{ translationService.translate('codeText') }}"
          emptyPlaceholder="{{ translationService.translate('searchByCodeText') }}"
          placeholder="{{ translationService.translate('searchByCodeText') }}"
          [formGroup]="filterForm"
          formControlName="codes"
          [data]="codeFilterList"
        >
        </app-dropdown-search-single-select>
        <app-dropdown-search-single-select
          id="typeDropdown"
          label="{{ translationService.translate('typeColumnText') }}"
          emptyPlaceholder="{{ translationService.translate('searchTypeLabelText') }}"
          placeholder="{{ translationService.translate('searchTypeLabelText') }}"
          [formGroup]="filterForm"
          formControlName="types"
          [data]="typeFilterList"
        >
        </app-dropdown-search-single-select>
      </div>
    </form>
  </mat-card>

  <div id="repairs-screen-table" class="cam-table table-container">
    <mic-table #paginatedTable class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
      <ng-container *micTableNoData>
        <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"></mic-empty-state>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'rmpartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="rollPartNumberList"
          [formControl]="getControl(item, 'rmpartNumber')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'rrpartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'rrpartNumber')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'ropartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'ropartNumber')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'freeRepairPartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'freeRepairPartNumber')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'repairDemeritPartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'repairDemeritPartNumber')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'adrrpartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'adrrpartNumber')"
        ></mic-dropdown-search>
      </ng-container>
      <ng-container *micCellTemplate="let item; name: 'adropartNumber'">
        <mic-dropdown-search
          micDropdownAccessibility
          emptyPlaceholder="No data found"
          subscriptSizing="dynamic"
          [virtualScroll]="true"
          [widthConfig]="{ width: '100%' }"
          [data]="finishedPartNumberList"
          [formControl]="getControl(item, 'adropartNumber')"
        ></mic-dropdown-search>
      </ng-container>
    </mic-table>
  </div>
  <mic-modal class="modalC" #discardConfirmation (result)="onDiscardModalClosed($event)"></mic-modal>
  <ng-template #discardContent>{{ translationService.translate('unSaveChangesText') }}</ng-template>
</div>
